/* eslint-disable */
import { Typography } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import WizardForm from '~/components/WizardForm';
import { useGetPayloadWithProvided } from '~/controllers/wizard';
import Section from '~/layouts/Section ';
import { Stage } from '~/types/Application';
import { Draft } from '~/types/Draft';
import buildNamePath from '~/utils/buildNamePath';
import { DirectionProp } from '~/types/Direction';
import { useDirection } from '~/hooks/i18nHooks';
import direction from '~/utils/direction';
import ReviewItem from '../components/ReviewItem';
const n = buildNamePath('reviewCompanyQuestionnaire');

const CompanyQuestionnaire: FC = () => {
  const { t } = useTranslation('ksaReview');
  const [form] = WizardForm.useForm();
  const payload = useGetPayloadWithProvided();
  const dir = useDirection();

  if (!payload) return null;

  const companyQuestionnaire = payload?.companyQuestionnaire as any;

  return (
    <Container className="ReviewCompanyQuestionnaire" dir={dir}>
      <WizardForm<Draft<'reviewCompanyQuestionnaire'>>
        stage={Stage.ksaReview}
        payloadKey="reviewCompanyQuestionnaire"
        form={form}
      >
        <PageTitle>
          {t('Company Questionnaire')}
        </PageTitle>

        <Section>
          <ReviewItem
            label={t(
              'Are you, or a direct family member, or any individual associated with your business, a Politically Exposed Person (PEP)?'
            )}
          >
            <Typography.Paragraph>
              {companyQuestionnaire?.authorizedRepresentative?.hasFamilyMembers
                ? t('Yes')
                : t('No')}
            </Typography.Paragraph>
          </ReviewItem>
          {companyQuestionnaire?.authorizedRepresentative?.hasFamilyMembers && (
            <ReviewItem label={t('Name of Politically Exposed Person')}>
              <Typography.Paragraph>
                {companyQuestionnaire?.authorizedRepresentative?.familyMemberName}
              </Typography.Paragraph>
            </ReviewItem>
          )}
          <br />
          <br />

          <ReviewItem
            label={t(
              'Do your business activities, owners, or officials have any direct or indirect involvement with, or interests in, any sanctioned countries, territories, or individuals/entities listed on sanctions lists? \n' +
                'This includes any current operations, offices, financial relationships, or planned engagements that may contravene applicable sanctions regulations.'
            )}
          >
            <Typography.Paragraph>
              {companyQuestionnaire?.sanction?.hasDealings ? t('Yes') : t('No')}
            </Typography.Paragraph>
          </ReviewItem>
          {companyQuestionnaire?.sanction?.hasDealings && (
            <ReviewItem
              label={t(
                'the countries, individuals, business activities, goods/services involved (including their use, origin, and destination)'
              )}
            >
              <SanctionDescParagraph>
                {companyQuestionnaire?.sanction?.briefDescription}
              </SanctionDescParagraph>
            </ReviewItem>
          )}
        </Section>
      </WizardForm>
    </Container>
  );
};

const Container = styled.div<DirectionProp>`
  .ReviewCompanyQuestionnaire-TitleWithHint {
    display: flex;
    align-items: center;
    .Hint {
      ${direction.margin.left(8)};
    }
  }
`;

const PageTitle = styled(Typography.Title)`
  margin-bottom: 60px !important;
`;

const SanctionDescParagraph = styled(Typography.Paragraph)`
  white-space: pre-line;
  font-weight: 500;
`;

// @ts-ignore
export default CompanyQuestionnaire;
